import { DatabasesDisplayGridRowData } from '@tableau/data-catalog-client-components';
import { Action } from 'redux';
import { GroupDatabases } from '../AppActionTypes';

export interface GroupDatabasesAction extends Action {
  items: ReadonlyArray<DatabasesDisplayGridRowData>;
}

export function groupDatabasesAction(items: ReadonlyArray<DatabasesDisplayGridRowData>): GroupDatabasesAction {
  return {
    type: GroupDatabases,
    items
  };
}
